(function () {
  'use strict';

  function start() {
    var cartToggle = document.querySelector('.uso-compact-header #cartToggle');
    var cartDropdown = document.querySelector('.uso-compact-header #dropdown-cart');
    if (cartToggle && cartDropdown) {
      function syncCartExpanded() {
        var expanded = !cartDropdown.hidden && window.getComputedStyle(cartDropdown).display !== 'none';
        cartToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
      cartToggle.addEventListener('click', function (event) {
        if (event.detail === 0 && window.dropdowncart_type !== 'click' && !('ontouchstart' in document) && window.jQuery) {
          window.jQuery(cartDropdown).stop(true, true).slideToggle('fast');
        }
      });
      var cartObserver = new MutationObserver(syncCartExpanded);
      cartObserver.observe(cartDropdown, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
      syncCartExpanded();
    }

    var slot = document.querySelector('.uso-compact-header .uso-rewards-slot');
    if (!slot || !document.body) return;

    var prepared = new WeakSet();

    function prepareLauncher(launcher) {
      if (prepared.has(launcher)) return;
      prepared.add(launcher);
      if (launcher.matches('button, a[href], input, select, textarea')) return;
      if (!launcher.hasAttribute('role')) launcher.setAttribute('role', 'button');
      if (!launcher.hasAttribute('tabindex')) launcher.setAttribute('tabindex', '0');
      if (launcher.getAttribute('role') !== 'button') return;

      var spacePressed = false;
      launcher.addEventListener('keydown', function (event) {
        if (event.target !== launcher || event.defaultPrevented) return;
        if (event.key === 'Enter') {
          event.preventDefault();
          if (!event.repeat) launcher.click();
        } else if (event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          spacePressed = true;
        }
      });
      launcher.addEventListener('keyup', function (event) {
        if (event.target !== launcher) return;
        if (event.key === ' ' || event.key === 'Spacebar') {
          var activate = spacePressed && !event.defaultPrevented;
          spacePressed = false;
          event.preventDefault();
          if (activate) launcher.click();
        }
      });
      launcher.addEventListener('blur', function () {
        spacePressed = false;
      });
    }

    function moveLaunchers() {
      if (!slot.isConnected) {
        slot = document.querySelector('.uso-compact-header .uso-rewards-slot');
        if (!slot) return;
      }
      var launchers = document.querySelectorAll('body > .swell-tab');
      for (var index = 0; index < launchers.length; index += 1) {
        var launcher = launchers[index];
        prepareLauncher(launcher);
        slot.appendChild(launcher);
      }
    }

    moveLaunchers();
    var observer = new MutationObserver(function (mutations) {
      for (var index = 0; index < mutations.length; index += 1) {
        if (mutations[index].addedNodes.length) {
          moveLaunchers();
          break;
        }
      }
    });
    observer.observe(document.body, { childList: true });
    document.addEventListener('shopify:section:load', moveLaunchers);
    window.addEventListener('pageshow', moveLaunchers);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
